import React, { FunctionComponent } from 'react';
import Swiper from 'react-id-swiper';

import { DirectionWidgetItem, DirectionWidgetItemProps } from '../DirectionWidgetItem';
import { Arrow, Wrapper } from './styles';
import { ReactIdSwiperChildren, ReactIdSwiperRenderProps } from 'react-id-swiper/lib/types';

interface Props {
  items: DirectionWidgetItemProps[];
}

const renderPrevButton: unknown = () => <Arrow className="swiper-button-prev" type="prev" />;
const renderNextButton: unknown = () => <Arrow className="swiper-button-next" type="next" />;

export const DirectionWidgetSlider: FunctionComponent<Props> = (props) => {
  const { items } = props;

  const params = {
    observer: true,
    observeParents: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
  };

  return (
    <Wrapper>
      <Swiper
        {...params}
        renderPrevButton={renderPrevButton as ReactIdSwiperRenderProps}
        renderNextButton={renderNextButton as ReactIdSwiperRenderProps}
      >
        {
          items?.map((item) => (
            <div key={item.destinationName} style={{ width: '260px' }}>
              <DirectionWidgetItem {...item} />
            </div>
          )) as ReactIdSwiperChildren
        }
      </Swiper>
    </Wrapper>
  );
};
//
//
